export { RatingComponent } from './rating.component';
export { RatingModule } from './rating.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/rating/index.js
// module id = 545
// module chunks = 10